export const aduanasCoordinadoras = {
  '60804010-2': 'Metropolitana',
  '60804002-1': 'Iquique',
  '60804008-0': 'Valparaíso',
  '60804000-5': 'Central'
};
